/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

export type ApiInspectionsV1LoadsListStatus = typeof ApiInspectionsV1LoadsListStatus[keyof typeof ApiInspectionsV1LoadsListStatus];


export const ApiInspectionsV1LoadsListStatus = {
  Missed: 'Missed',
  Not_needed: 'Not needed',
  Present: 'Present',
  Unassigned: 'Unassigned',
} as const;
